import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    primaryBackground: "rgba(0, 93, 189, 1)",
    secondaryBackground: "rgba(56, 65, 74, 1)",
    // set per tenant in its appointment configuration; blank shows the footer's default note
    disclaimer: "",
    phone: [],
    logo: "",
};

const dynamicStoreSlice = createSlice({
    name: 'dynamicStore',
    initialState,
    reducers: {
        updateConfigurationData: (state, action) => {
            state.primaryBackground = action.payload.primaryColor || initialState.primaryBackground;
            state.secondaryBackground = action.payload.secondaryColor || initialState.secondaryBackground;
            state.disclaimer = String(action.payload.disclaimer || "").trim();
            state.phone = action.payload.phone_number || initialState.phone;
        },
        updateLogo: (state, action) => {
            state.logo = action.payload;
        }
    },
});

export const { updateConfigurationData, updateLogo } = dynamicStoreSlice.actions;

export default dynamicStoreSlice.reducer;